<ion-grid *transloco="let t; prefix: 'courseScheduleComp'">
    <ion-row class=" ion-align-items-stretch ion-hide-sm-down static-wrapper">
        <ion-col  class="ion-justify-content-center ion-no-padding">
            <ion-grid class="wrapper ion-justify-content-between">
                <ion-row class="ion-justify-content-between ion-align-items-end">
                    <ion-col class="title">{{ t('selfStudy') }}</ion-col>
                    <ion-col size="auto" class="score">{{ selfStudy }}</ion-col>
                </ion-row>

                <ion-row class="ion-hide-sm-down ion-padding-top">
                    <ion-col class="progress" *ngIf="completedSS!= '_'">{{ t('completed') }}: {{ completedSS }}
                        /{{ totalSS }}
                    </ion-col>
                    <ion-col class="progress" *ngIf="completedSS ==='_'">{{ t('completed') }}: {{ completedSS }}
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>


        <ion-col  class="ion-justify-content-center ion-no-padding">
            <ion-grid class="wrapper ion-justify-content-between">
                <ion-row class="ion-justify-content-between ion-align-items-end">
                    <ion-col class="title">{{ t('attendance') }}</ion-col>
                    <ion-col size="auto" class="score" *ngIf="totalLessons">{{ attendance }}</ion-col>
                </ion-row>

                <ion-row class="ion-hide-sm-down ion-padding-top">
                    <ion-col class="progress" *ngIf="missedLessons!= '_'">{{ t('skipLessons') }} : {{ missedLessons }}
                        /{{ totalLessons }}
                    </ion-col>
                    <ion-col class="progress" *ngIf="missedLessons=== '_'">{{ t('skipLessons') }}: {{ missedLessons }}
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>


        <ion-col class="ion-justify-content-center ion-no-padding">
            <ion-grid class="wrapper ion-justify-content-between">
                <ion-row class="ion-justify-content-between ion-align-items-end">
                    <ion-col class="title">{{ t('tests') }}</ion-col>
                    <ion-col size="auto" class="score" *ngIf="passedExams!== '_'">{{ passedExams }}/{{ totalExams }}
                    </ion-col>
                    <ion-col size="auto" class="score" *ngIf="passedExams=== '_'">{{ passedExams }}</ion-col>
                </ion-row>

                <ion-row class="ion-hide-sm-down ion-padding-top">
                    <ion-col class="progress"
                             *ngIf="passedExamsMarkAvg!== '_'">{{ t('averageScore') }} {{ passedExamsMarkAvg }}
                        /{{ maxMark }}
                    </ion-col>
                    <ion-col class="progress"
                             *ngIf="passedExamsMarkAvg=== '_'">{{ t('averageScore') }} {{ passedExamsMarkAvg }}
                    </ion-col>
                </ion-row>

                <ion-row class="ion-hide-sm-down">

                    <ion-col class="progress"> {{t('finalAverageScore')}} {{ finalExam }}  /{{ maxMark }}
                    </ion-col>
                </ion-row>

            </ion-grid>
        </ion-col>
    </ion-row>

    <ion-row class=" ion-align-items-stretch ion-hide-sm-up">

        <ion-col size-sm="12" size-xs="12" size-lg="4" size-md="4" class="ion-justify-content-center ion-no-padding">
            <ion-grid class="wrapper">
                <ion-row class="ion-justify-content-between ion-align-items-end">
                    <ion-col class="title">{{ t('selfStudy') }}</ion-col>
                    <ion-col size="auto" class="score">{{ selfStudy }}</ion-col>
                </ion-row>
                <ion-row class="ion-justify-content-between ion-align-items-end">
                    <ion-col class="title">{{ t('attendance') }}</ion-col>
                    <ion-col size="auto" class="score">{{ attendance }}</ion-col>
                </ion-row>
                <ion-row class="ion-justify-content-between ion-align-items-end">
                    <ion-col class="title">{{ t('tests') }}</ion-col>
                    <ion-col size="auto" class="score"  *ngIf="passedExams!== '_'">{{ passedExams }}/{{ totalExams }}</ion-col>
                    <ion-col size="auto" class="score"  *ngIf="passedExams=== '_'">{{ passedExams }}</ion-col>
                </ion-row>


            </ion-grid>
        </ion-col>

    </ion-row>

</ion-grid>






